import { StarIcon } from "@heroicons/react/24/solid";
import React, { FC } from "react";
import { PropertyToEdit } from "redux/reducers/Properties/PropertiesSliceTypes";

export interface StartRatingProps {
  className?: string;
  point?: number;
  reviewCount?: number;
  propertyData?: PropertyToEdit | null;
  reviewTotal?: number;
}

const StartRating: FC<StartRatingProps> = ({
  className = "",
  propertyData,
  reviewCount,
  reviewTotal,
}) => {
  const review = propertyData?.average?.average_review || reviewCount || 0;
  const count = propertyData?.average?.count || reviewTotal || 0;
  const formattedReview = review ? review.toFixed(1) : null;
  
  // If no reviews at all, show "New" badge or "No reviews yet"
  if (!formattedReview || count === 0) {
    return (
      <div
        className={`nc-StartRating flex items-center space-x-1 text-sm ${className}`}
        data-nc-id="StartRating"
      >
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
          New Listing
        </span>
      </div>
    );
  }

  return (
    <div
      className={`nc-StartRating flex items-center space-x-1 text-sm ${className}`}
      data-nc-id="StartRating"
    >
      <div className="pb-[2px]">
        <StarIcon className="w-[18px] h-[18px] text-orange-500" />
      </div>
      <span className="font-medium">{formattedReview}</span>
      <span className="text-neutral-500 dark:text-neutral-400">
        ({count} {count === 1 ? 'review' : 'reviews'})
      </span>
    </div>
  );
};

export default StartRating;